export default {
    name: 'v5-icon-horn',
    render: function (h) {
        return h('svg', {
            attrs: {
                class: 'icon',
                height: '32',
                viewBox: '0 0 1024 1024',
                width: '32',
                xmlns: 'http://www.w3.org/2000/svg'
            }
        }, [
            h('path', {
                attrs: {
                    d: 'M845.815 750.614h.059v-.364l-.059.364zM726.589 196.598c-4.46-2.846-8.894-5.169-14.3-5.169-13.207 0-23.856 11.371-23.856 25.385 0 10.12 5.641 18.221 13.61 22.82 87.68 54.344 146.638 155.215 146.638 270.816 0 115.511-58.905 216.346-146.466 270.694-7.683 4.464-14.299 12.839-14.299 23.201 0 14.029 10.704 25.4 23.882 25.4 5.295 0 9.493-2.169 14.098-4.983 101.749-63.087 170.177-180.157 170.177-314.312.003-133.85-68.138-250.687-169.484-313.852zm27.679 313.868c0-78.664-40.138-147.299-99.848-184.237-2.705-1.5-9.061-4.449-13.525-4.449-13.264 0-23.998 11.402-23.998 25.476 0 9.459 4.72 17.881 11.915 22.298C674.968 397.4 706.1 450.05 706.1 510.465c0 61.451-32.228 114.913-79.706 142.391-6.907 4.464-11.479 12.594-11.479 21.827 0 14.089 10.73 25.519 23.968 25.519 5.641.032 12.343-3.482 12.343-3.482 61.465-36.434 103.042-106.157 103.042-186.254zM512 127.99L320.062 319.684v.313H127.304v383.888H319.04L512 895.639h64.112V127.99H512zM319.041 639.965H192.037V383.79h128.025v.313L512 191.883v639.739L319.041 639.965z',
                    fill: 'currentColor'
                }
            })
        ]);
    }
};
